//Header
const person = {
  name: 'Yalin(Corey) Chen',
  city: 'Montreal, QC, Canada',
  email: 'yc.about@gmail.com',
  note: 'Montreal, Canada | Available for new opportunities in 2021',
  title1: 'Full Stack Software Developer',
  selectedSkills1: 'Reactjs, Nodejs, MySQL|Mongodb|Blockchain and Python (data)',
  note1: "Master's degree in computer science",
  title2: 'Cogntive Psychology Ph.D.',
  selectedSkills2: 'Human cognition research + Data analysis',
  note2: "",
  linkedin: 'https://www.linkedin.com/in/ycabout/',
  github: 'https://github.com/ycAbout',
  researchGate: 'https://www.researchgate.net/profile/Yalin_Chen3',
}

//resume
const summaryList = [
  'Full stack developer & Data Science skill set: Javascript full stack (Reactjs + Nodejs + SQL/MongoDB/Blockchain) and Python for data science.',
  'Cognitive Psychology Ph.D.: Design experiments, collect data and apply statistical models (e.g., ANOVA, Regression) to acquire insights of human learning, memory, and cognition.'
]
const experiences = {
  job1: {
    title: "Data and Full Stack Software Developer (2019 – Present)",
    company: "Douglas mental health institute, affilated to McGill University",
    detail: "While working as a team member of LORIS developer team at Montreal Neurological Institute, I am also in charge of establishing a LORIS instance from scratch and maintaining it in all aspects to meet the user needs at Douglas Mental Health University Institute. Some of the languages and tools I work with including Reactjs, Nodejs, Python, MYSQL, Linux, Git, and some system admin tools."
  },
  job2: {
    title: " Data-driven Postdoctoral Researcher (2013 – 2019)",
    company: "Department of Psychology, University of Saskatchewan",
    detail: "Design experiments, collect data and apply statistical models (e.g., ANOVA, Regression) to data to acquire insights of human learning, memory, and cognition. Taught undergraduate course: Research in Advanced Cognitive Science"
  }
}
const eduList = [
  'Master in Computer Science 2017-2019 | University of Saskatchewan (Saskatoon, Canada)',
  'Ph.D. in Cognitive psychology 2013 | Joint program of the University of Saskatchewan (Saskatoon, Canada, 2012-2013) and Nanjing Normal University (Nanjing, China)',
  'Bechalor in Human Resource Management (Psychology stream) 2007 | Department of Psychology, Henan University, Kaifeng, China. ',
]
const skillsList = [
  'Programing: Reactjs, Nodejs, Python, SQL, MongoDB, Blockchain (Hyperledeger Fabric), Linux, SPSS, Git',
  'Research: Data-based human research, experiment design, data analysis',
  'Other: English-Chinese bilingual, event-related brain potential (ERP)'
]
const achievementsList = [
  'Published 25 peer-reviewed academic journal articles & 16 conference presentations.',
  'Selected national awards: NSERC PDF fellowship, $ 90,000 CAD. Joint PhD student award, China-Canada, 2012-2013. $19,200 CAD yearly. The Third Prize for Excellent Paper in 10th CPPC, Jinhua, China, 2010.'
]

//wall of fame
const awardList = [
  'Post-doctoral fellowship from Natural Sciences and Engineering Research Council of Canada (NSERC), $ 90,000 CAD.',
  'Excellent Graduates Award – three times: Twice from Nanjing Normal University, 2013 (For Ph.D.) and 2010 (For M.S.), once from Henan University, 2007 (For B.Admin).',
  'Joint PhD student award, China-Canada, 2012-2013. $19,200 CAD yearly.',
  'Scholarship for Outstanding Students – three times: Once is Jingwen Zhu Special Scholarship 2012 (awarded to top three students annually); once is Jingwen Zhu Regular Scholarship 2010 from Nanjing Normal University. Another is Regular Scholarship 2006 from Henan University.',
  'Outstanding Postgraduate Students Award – twice, from Nanjing Normal University, 2011(For Ph.D.) and 2009 (For M.S.).',
  'Excellent Master Thesis of Nanjing Normal University, Nanjing Normal University, 2011.',
  'The Third Prize for Excellent Paper in 10th Chinese Physiopsychology Conference (CPPC), Jinhua, 2010.',
  'Outstanding Prize for level A in National English Contest for College Students, National English Contest for College Students, 2006.',
  'Outstanding Student Leader, Henan University, 2004.'
]
const grantList = [
  'An ERP study of the neural mechanisms of number, time, and space processing, Research Innovation Program for College Graduates of Jiangsu Province, China, 2011– 2013, 10,000 RMB, Leading researcher.',
  'The effect of object orientation in space memory, National Natural Science Foundation of China, 2013– 2015, 200,000 RMB, Co-researcher.',
  'Syntactic priming in Chinese sentence comprehension: Evidence from eye movements and ERP, National Natural Science Foundation of China, 2012–2014, 200,000 RMB, Co-researcher.'
]

const paperList = [
  'Chen, Y., Orr, A., & Campbell, J.I.D. (2019). What is learned in procedural learning? The case of alphabet arithmetic. Journal of Experimental Psychology: Learning, Memory, and Cognition.',
  'Chen, Y., & Campbell, J.I.D. (2019). Evidence for a retrieval over a sum counting theory of adults’ simple addition. Canadian Journal of Experimental Psychology.',
  'Chen, Y., Campbell, J.I.D., & Loehr, J. (2019). Is an automatic min-counting strategy for adults’ simple addition possible? A behavioural and ERP study of size congruency effect. Neuropsychologia.',
  'Neudorf, J., Chen, Y., & Campbell, J.I.D. (2018). Retrieval Priming in Product Verification: Evidence from Retrieval-induced Forgetting. Journal of Numerical Cognition.',
  'Chen, Y., & Campbell, J.I.D. (2018). “Compacted” Procedures for Adults’ Simple Addition: A Review and Critique of the Evidence. Psychonomic Bulletin & Review, 25, 739-753. ',
  'Chen, Y., & Campbell, J.I.D. (2017). An Evaluation of Sex and Cultural Differences in Arithmetic Retrieval-Induced Forgetting. Journal of Cognitive Psychology, 29(8), 949-962.',
  'Chen, Y., & Campbell, J.I.D. (2017). Transfer of Training in Simple Addition. The Quarterly Journal of Experimental Psychology, 71(6), 1312 – 1323.',
  'Campbell, J.I.D., Chen, Y., Allen, K., & Beech, L. (2016). Transfer of Training in Alphabet Arithmetic. Memory & Cognition, 44, 1288-1300.',
  'Chen, Y., & Campbell, J.I.D. (2016). Operator Priming and Generalization of Practice in Adults’ Simple Arithmetic. Journal of Experimental Psychology: Learning, Memory, and Cognition, 42, 627-635.',
  'Chen, Y., Yanke, J., & Campbell, J.I.D. (2016). Language-Specific Memory for Everyday Arithmetic Facts in Chinese-English Bilinguals. Psychonomic Bulletin & Review, 23, 526-532.',
  'Chen, Y., & Campbell, J.I.D. (2015). Operator and Operand Preview Effects in Simple Addition and Multiplication: A Comparison of Canadian and Chinese Adults. Journal of Cognitive Psychology, 27, 326–334.',
  'Campbell, J.I.D., Dufour, K.D., & Chen, Y. (2015). Retrieval-Induced Forgetting of Multiplication Facts and Identity Rule. Memory & Cognition, 43, 672–680.',
  'Chen, Y., & Campbell, J.I.D. (2014). Generalization Effects in Canadian and Chinese Adults’ Simple Addition. Canadian Journal of Experimental Psychology. 68(3), 152–157.',
  'Campbell, J.I.D., Chen, Y., & Maslany, A. (2013). Retrieval-induced forgetting of arithmetic facts across cultures. Journal of Cognitive Psychology, 25(6), 759–773.',
  'Chen, Y., Campbell, J. I. D., & Liu, C. (2013). The N3 is Sensitive to Odd-Even Congruency Information in Arithmetic Fact Retrieval. Experimental Brain Research, 225(4), 603–611.',
  'Shen, W., Liu, C., Zhang, X., Zhao, X., Zhang, J., Yuan, Y., & Chen, Y. (2013). Right Hemispheric Dominance of Creative Insight: An Event-Related Potential Study. Creativity Research Journal. 25(1), 48–58.',
  'Chen, Y., & Liu, C. (2013). Relationships and Independence of Human Number, Time and Space Processing. Chinese Science bulletin. 58(25), 2609–2617. (Reported by EurekAlert!)',
  'Wang, D., Liu, C., & Chen, Y. (2013). The ERP Correlates of Visual and Auditory Processing in Mental Subtraction and Multiplication. Studies of Psychology and Behavior. 11(3), 325-332.',
  'Chen, Y., Liu, C., & Zhang, X. J. (2012). The Probability and Mental Representation. Advances in Psychological Science. 20(1), 65–74.',
  'Zhang, X., Liu, C., Liu, Y., Chen, Y., & Shen, W. (2012). The Neural Basis of Spatial Reasoning: An Event-related Potential Study. Psychological Science (in Chinese). 35(4), 842–847.',
  'Chen, Y., Liu, C., Zhang, X., Xu, X., & Shen, W. (2011). An ERP Study of Mixed Strategy Selection in Mental Arithmetic. Acta Psychologica Sinica. 43, 384–395.',
  'Chen, Y., & Liu, C. (2011). The Intuition in Number Processing. Journal of East China Normal University (Educational Science). 29(4), 57–63.',
  'Shen, W, Liu, C., Zhang, X., & Chen, Y. (2011). The Time Course and Hemispheric Effect of "Insight" in Three-character Chinese Riddles Task: An ERP Study. Acta Psychologica Sinica. 43, 229–240.',
  'Han, P., & Chen, Y. (2011). The Analysis of Chinese Academic Psychology journal citation network. Journal of Southwest University for Nationalities (Humanities and Social Science), (4), 230–234.',
  'Chen, Y., Liu, C., & Chen, D. (2010). The Strategy Selection in Mental Arithmetic. Advances in Psychological Science, 18, 193–199.',
  'Chen, Y., & Liu, C. (2009). Choking Under Pressure Relate to Working Memory. Advances in Psychological Science, 17, 691–698. Note: This article was reprinted by Information Center for Social Sciences, RUC (B4, Psychology).'
]

const bookList = [
  'Neuroscience, Psychology and Religion, Translation (From English to Chinese), Chapter 6 and 9. 2014 May. Beijing: Educational Science Publication House.(Original authors: M. Jeeves & W.S. Brown)',
  'Physiological Psychology (In Chinese), Contributed in data collection. 2012 March. Beijing: Higher Education Press.'
]

const conferenceList = [
  "Chen, Y., Campbell, J.I.D., Neudorf, J., & Loehr, J. No automatic min counting for adults’ simple addition: A behavioural and ERP study of size congruency effect. CSBBCS 27th Annual Meeting. June 2 – 4, 2017. Oral presentation, Regina, SK, Canada.",
  "Campbell, J.I.D.*, Neudorf, J., & Chen, Y. Retrieval-induced forgetting of simple addition by verification of multiplication counterparts. CSBBCS 27th Annual Meeting. June 2 – 4, 2017. Oral presentation, Regina, SK, Canada.",
  "Chen, Y., Campbell, J.I.D., Neudorf, J., & Loehr, J. A Behavioural and ERP Study of Size Congruency Effect in Adults' Simple Addition: No Min Counting. Banff Annual Seminar in Cognitive Science (BASICs). May 5 – 6, 2017. Paper Poster, Banff, AB, Canada.",
  "Chen, Y., Campbell, J.I.D., Neudorf, J., & Loehr, J. Is an automatic min-counting strategy for adults’ simple addition possible? A behavioural and ERP study of size congruency effect. ICPS2017 International Convention of Psychological Science. March 23–25, 2017. Poster presentation, Vienna, Austria.",
  "Campbell, J.I.D.* & Chen, Y. “Compacted” Procedures for Adults’ Simple Addition: A Review and Critique of the Evidence. ICPS2017 International Convention of Psychological Science. March 23–25, 2017. Oral presentation, Vienna, Austria.",
  "Chen, Y. & Campbell, J.I.D. Do adults really use automatic counting to solve very simple addition problems? CSBBCS 26th Annual Meeting. June 24–26, 2016. Oral presentation, Ottawa, Ontario, Canada.",
  "Campbell, J.I.D.* & Chen, Y. Adult addition by \"compacted counting“: Does the evidence add up? CSBBCS 26th Annual Meeting. June 24–26, 2016. Oral presentation, Ottawa, Ontario, Canada.",
  "Chen, Y. & Campbell, J.I.D. Operator Preview and Generalization of Practice in Adults’ Simple Arithmetic. Psychonomic Society's 56th Annual Meeting. November 19–22, 2015. Paper Poster, Chicago, Illinois, USA.",
  "Campbell, J.I.D.*, Chen, Y., Allen, K., & Beech, L. Transfer of Training in Alphabet Arithmetic. Psychonomic Society's 56th Annual Meeting, November 19–22, 2015. Oral presentation, Chicago, Illinois, USA.",
  "Chen, Y. & Campbell, J.I.D. Generalization Effects in Simple Arithmetic Across Chinese and Canadian Adults. Psychonomic Society's 55th Annual Meeting. November 20–23, 2014. Paper Poster, Long Beach, CA, USA.",
  "Campbell, J.I.D.*, Dufour, K.D. & Chen, Y. Retrieval-Induced Forgetting of Simple Addition and Multiplication. Psychonomic Society's 55th Annual Meeting, 2014 November 20–23. Oral presentation, Long Beach, CA, USA.",
  "Chen, Y. & Campbell, J.I.D. Generalization Effects in Canadian and Chinese Adults’ Simple Addition. CSBBCS (The Canadian Society for Brain, Behaviour and Cognitive Science) 24th Annual Meeting. July 3–5, 2014. Paper Poster, Ryerson University, Toronto, ON, Canada.",
  "Chen, Y. & Campbell, J.I.D. Operator and Operand Preview Effects in Simple Addition and Multiplication: A Comparison of Canadian and Chinese Adults. 33rd Banff Annual Seminar in Cognitive Science (BASICs). May 2–3, 2014. Paper Poster, Banff, AB, Canada.",
  "Chen, Y., Liu, C., Zhang, X., Xu, X., & Shen, W. An ERP Study of Mixed Strategy Selection in Mental Arithmetic. 2012 Beijing International Conference on the Neuroscience of Mathematical Cognition and Learning. June 15–16, 2012. Paper Poster, Beijing Normal University, Beijing, China.",
  "Chen, Y., Liu, C., & Zhang, X. J. The Number in Decision Making: The Probability and Mental Representation. The 14th National conference of Psychology, October 21–23, 2011. Oral presentation, the Fourth Military Medical University, Xi’an, China.",
  "Chen, Y., Liu, C., Zhang, X., Xu, X., & Shen, W. The Strategy Selection in Mental Arithmetic: An ERP Study. The 10th Chinese Physiopsychology Conference (CPPC), October 11–14, 2010. Excellent paper presentation, Zhejiang Normal University, Jinhua, China.",
  "Note. The * marks the presenters other than Yalin Chen. "
]

const projects = {
  group1: {
    name: 'Blockchain',
    project1: {
      title: "Psychology test Blockchain (link private)",
      tech: 'Reactjs + Nodejs + Hyperledger Composer + MongoDB',
      feature: [
        'Helps to establish the single source of truth with that you control your own data.',
        'The essential information and access controls are immutable and available on every node.',
      ],
      link: 'https://github.com/ycAbout/psytest'
    },
  },
  group2: {
    name: 'Web and Mobile',
    project1: {
      title: "LORIS",
      tech: 'Python, Reactjs, Nodejs, MYSQL, Linux, Git, and some system admin tools.',
      feature: [
        'LORIS is a self-hosted web application that provides data- and project-management for neuroimaging research.',
        'It makes it easy to manage large datasets including behavioural, clinical, neuroimaging and genetic data acquired over time or at different sites.'
      ],
      link: 'https://github.com/aces/Loris'
    },
    project2: {
      title: "YFigure javascript library",
      tech: 'Javascript + d3js',
      feature: [
        'There are plenty figure libraries, but yfigure aims to provide an easier to use but very flexible tool to draw a figure on html.',
        'Clickable legend out of box',
        '90+ customizable features'
      ],
      link: 'https://y-figure.web.app/'
    },
    project3: {
      title: "Personal website template",
      tech: 'Reactjs (HTML + CSS (Bootstrap) + Javascript)',
      feature: [
        'Open source code, everyone can use. You can use firebase to host your website for free.',
        'You only need to fill your own data and pick your own photo.',
        'It looks like the current website.'
      ],
      link: 'https://github.com/ycAbout/personal-website-react'
    },
    project4: {
      title: "Automatically post ads online",
      tech: 'Python 3 + Selenium WebDriver',
      feature: [
        'Automatically login and post ad online, which saves time and avoid repetitive work.',
        'Using real estate and kijiji as an instance via the Firefox browser.',
        'The code can be modified easily for other usage.'
      ],
      link: 'https://github.com/ycAbout/auto-post-ads-python'
    },
    project5: {
      title: "Web scrapper and display",
      tech: 'Python 3 + BeautifulSoup 4 + matplotlib 3 + scipy + numpy',
      feature: [
        'Automatically get, analyze, and display data sets online, which save time and avoid repetitive work.',
        'Using some of the NASDAQ stocks for an instance.',
        'The code can be modified easily for other websites.'
      ],
      link: 'https://github.com/ycAbout/web-scrapper-analyses-python'
    },
  },
  group3: {
    name: 'User Experience',
    project1: {
      title: "Obvious user experience errors to avoid: A brief heuristic evaluation of a job application website",
      tech: "Heuristic evaluation according to Jakob Nielsen's 10 general principles",
      feature: [
        'This simple method only requires a couple hours of human labor',
      ],
      link: 'https://github.com/ycAbout/UX_heuristic_jobSite'
    },
  },
}

const courses = {
  frontEnd: ["ReactJS (Microsoft)", "React Router & Redux (Microsoft)", "HTML5 (W3Cx)"],
  HCI: ["Human Computer Interaction (Stanford)"]
}

const webSkills = {
  frontEnd: "HTML5, CSS, Javascript",
  backEnd: "Nodejs, Python",
  database: "MongoDB, Mysql, Blockchain",
  other: "Linux, Git, User Experience"
}

const dataSkillList = [
  'Advanced statistics',
  'SPSS',
  'Human Brain Analyses (ERP & EEG)',
  'Learning Machine Learning and AI'
]

const cognitiveArithmetic = {
  intro: '"An improvement of one-half standard deviation in mathematics and science performance at the individual level implies, by historical experience, an increase in annual growth rates of GDP per capita of 0.87%"',
  source: "--OECD, The High Cost of Low Educational Performance: The Long-Run Economic Impact of Improving Educational Outcomes (OECD, Paris, 2010).",
  effects: [
    "Problem size effect",
    "Retrieval induced forgetting",
    "Size congruency effect",
    "Transfer of training",
    "Cultural differences",
    "Odd-even effect",
    "Distance effect"
  ]
}

const recentPublication = {
  title: "Does the min-counting strategy for simple addition become automatized in educated adults? A behavioural and ERP study of the size congruency effect.",
  highlights: [
    "The min strategy should become automatized if assume automatic counting for addition.",
    "The min strategy inherently requires number comparison.",
    "Number comparison produces the size congruency effect (SCE).",
    "The present study found a robust SCE for number comparison but not for addition.",
    "No SCE ruled out the possibility of a min-counting strategy for adults’ addition."
  ],
  link: "https://www.sciencedirect.com/science/article/pii/S0028393218303853?via%3Dihub"
}

const uxHeuristics = {
  title: "10 Usability Heuristics for User Interface Design",
  heuristics: [
    "Visibility of system status",
    "Match between system and the real world",
    "User control and freedom",
    "Consistency and standards",
    "Error prevention",
    "Recognition rather than recall",
    "Flexibility and efficiency of use",
    "Aesthetic and minimalist design",
    "Help users recognize, diagnose, and recover from errors",
    "help and documentation"
  ],
  link: "https://www.nngroup.com/articles/ten-usability-heuristics/"
}

const gaming = {
  title: "The Psychology of Esports: A Systematic Literature Review",
  contents: [
    '"The aim of the present paper was to review the main topics of psychological interest about esports and then to examine the similarities of esports to professional and problem gambling. As a result of a systematic literature search, eight studies were identified that had investigated three topics: (1) the process of becoming an esport player, (2) the characteristics of esport players such as mental skills and motivations, and (3) the motivations of esport spectators."'
  ],
  link: "https://link.springer.com/article/10.1007%2Fs10899-018-9763-1"
}

export {
  person,
  eduList,
  awardList,
  grantList,
  paperList,
  bookList,
  conferenceList,
  experiences,
  summaryList,
  achievementsList,
  skillsList,
  projects,
  courses,
  webSkills,
  dataSkillList,
  cognitiveArithmetic,
  recentPublication,
  uxHeuristics,
  gaming
};
